import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <Header />
      <main><div className="inner-pg">
        <div className="content"><h1>Shipping</h1></div>
        <div className="content">
          <strong>PROCESSING TIMES</strong>
          <p>In-stock pieces generally ship within 1–3 business days after payment approval. Made-to-order timing is shown on the relevant product page or order confirmation. Estimates may change during busy periods or where additional verification is needed.</p>
          <strong>DELIVERY OPTIONS</strong>
          <p>Available services, prices, and estimated transit times are shown at checkout for the delivery address entered. Transit estimates begin when the carrier accepts the parcel and do not include studio processing time.</p>
          <strong>TRACKING AND SIGNATURE</strong>
          <p>When tracking is available, it will be sent to the contact information provided at checkout. High-value shipments may require an adult signature. Please ensure someone can receive the parcel at the supplied address.</p>
          <strong>INTERNATIONAL ORDERS</strong>
          <p>International recipients are responsible for import duties, taxes, brokerage, and local fees unless checkout clearly states that they are included. Customs processing may extend delivery time.</p>
          <strong>ADDRESS CHANGES AND DELIVERY ISSUES</strong>
          <p>Contact <u>print@shiskerstone.xyz</u> promptly if an address is incorrect. We cannot guarantee changes after dispatch. If a parcel is delayed, damaged, or marked delivered but missing, email us with the order number so we can help open a carrier enquiry.</p>
          <strong>MULTIPLE ITEMS</strong>
          <p>Items with different lead times may ship together when the full order is ready. If separate delivery is available, additional charges may apply.</p>
        </div>
      </div></main>
      <Footer />
    </div>
  );
}

export default Delivery;
